import { ModeProp } from '../Blocks.types';
import type { SkeletonProps } from './Skeleton.types';

export const skeletonCSSPropsKeys: (keyof SkeletonProps | keyof ModeProp)[] = [
  'height',
  'width',
];
